/** Officieel Schoonderwolf-beeldmerk uit het huisstijlhandboek. */
export function Beeldmerk({
  width = 44,
  alt = 'Schoonderwolf',
}: {
  width?: number;
  alt?: string;
}): React.JSX.Element {
  // De verhouding van het beeldmerk is 44 : 48.
  return (
    <img src="/beeldmerk.svg" alt={alt} width={width} height={Math.round((width / 44) * 48)} />
  );
}

/** Microsoft-logo als vier vierkantjes in de blauwtinten van het merk (design-handoff, scherm 1). */
export function MicrosoftMark(): React.JSX.Element {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" aria-hidden="true" focusable="false">
      <rect x="0" y="0" width="8" height="8" fill="var(--c-navy)" />
      <rect x="9" y="0" width="8" height="8" fill="var(--c-primary)" />
      <rect x="0" y="9" width="8" height="8" fill="var(--c-blue)" />
      <rect x="9" y="9" width="8" height="8" fill="var(--c-blue-light)" />
    </svg>
  );
}
